exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".pageContent[data-v-75a98980]{padding:3rem 1rem;min-height:90vh}.system-header[data-v-75a98980]{display:flex;align-items:center;margin-bottom:4rem}.system-header img[data-v-75a98980]{display:block;max-width:115px;margin-right:2.5rem}", ""]);

// exports
